const usLanguageMap = {
  en: 'English',
  es: 'Español'
};

const globalLanguageMap = {
  en: 'English',
  es: 'Español',
  'es-CL': 'Español (Chile)',
  fr: 'Français',
  it: 'Italiano',
  de: 'Deutsch',
  hr: 'Hrvatski',
  cs: 'Čeština',
  da: 'Dansk',
  hu: 'Magyar',
  nl: 'Nederlands',
  no: 'Norsk',
  pl: 'Polski',
  ro: 'Română',
  sv: 'Svenska',
  bg: 'Български',
  el: 'Ελληνικά',
  pt: 'Português',
  hi: 'हिन्दी',
  ar: 'العربية',
  tr: 'Türkçe',
  he: 'עברית',
  uk: 'Українська'
};

export function resolveLanguages(notUsInstance) {
  return notUsInstance ? globalLanguageMap : usLanguageMap;
}
